<template>
  <div class="box" :style="'top:' + boxPosition + '%'">
    <div class="image-area">
      <div
        class="bg"
        v-for="(n, index) in homeBg"
        :key="index"
        :style="bgStyle[index]"
      ></div>
    </div>
    <div class="demo-area">
      <div class="demo-inset">
        <div class="text1">在中日本人10万人をサポートするまるごとアプリ</div>
        <div class="text2">
          旅行・出張・駐在・留学のあらゆるシーンで役立つ機能が満載！
        </div>
        <div class="demo-arrow" @click="changePage">
          <Button class="btn">今すぐダウンロード</Button>
        </div>
      </div>
    </div>
    <div class="arrow-drop">
      <Icon class="arrow-icon" type="ios-arrow-dropdown" />
    </div>
  </div>
</template>
<script>
import { homeBg } from "../../images/home/index";
export default {
  data() {
    return {
      homeBg,
      bgStyle: [],
      boxPosition: 0,
      //////////////////////////////////////////////////////////////
      ///////////////////////////添加新的图片时务必修改此参数
      //////////////////////////////////////////////////////////////
      bgLength: 4,
    };
  },
  props: ['pageindex'],
  watch: {},
  methods: {
    init() {
      this.homeBg.forEach((n, index) => {
        let newStyle = "";
        newStyle += "background-image: url(" + n + ");";
        newStyle += "opacity:1;";
        newStyle += "left:" + (index * 100) / 8 + "%;";
        this.bgStyle.push(newStyle);
      });
    },
    changePage() {
      this.$emit("changeP",4);
    },

    timerSet() {},
    up() {
      this.boxPosition = "-100";
    },
    nomal() {
      this.boxPosition = "0";
    },
    down() {
      this.boxPosition = "100";
    },
  },
};
</script>
<style scoped>
.box {
  width: 100%;
  height: 100%;
  
}
.image-area {
  width: 200%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  animation: round 20s infinite linear;
}
.bg {
  width: 12.5%;
  background-position: center center;
  background-size: cover;
  height: 100%;
  left: 0;
  position: absolute;
  opacity: 0;
  display: inline-block;
  transition: all 0.5s;
}
.demo-area {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1;
  text-align: center;
  color: #fff;
}
.demo-inset {
  width: 14rem;
  height: 3.6rem;
  
  /* overflow: hidden; */

  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -7rem;
  margin-top: -1.8rem;
}
.demo-inset .text1 {
  font-size: 0.35rem;
}
.demo-inset .text2 {
  /* font-weight: bold; */
  letter-spacing: 5px;
  font-size: 0.8rem;
  height: 0.8rem;
  margin: 0 auto;
  /* margin-top: 0.5rem; */
}

/* .demo-arrow {
  position: absolute;
  width: 50px;
  height: 50px;
  
  left: 0;
  right: 0;
  bottom: 25px;
  margin: auto;
  font-size: 35px;
  opacity: 1;
} */
.demo-arrow {
  /* position: absolute; */
  /* bottom: 0; */
  margin-top: 2.8rem;
  position: absolute;
  left: 50%;
  margin-left: -1.4rem;
  
  
}
.demo-arrow .btn{
  font-size: 0.2rem;
  text-align: center;
}
.ivu-btn {
  height: 0.6rem;
  width: 2.4rem;
}
.arrow-drop{
  position: absolute;
  bottom: 1rem;
  width: 1rem;
  left: 50%;
  margin-left: -0.5rem;
  z-index: 9;
  animation: jumper 1s infinite linear;
}
.arrow-drop .arrow-icon{
  font-size: 0.5rem;
  
}
@keyframes jumper {
  0% {
    bottom: 25px;
    backgroud-position: 0 0;
  }
  50% {
    bottom: 45px;
    opacity: 0.5;
    background-position: 2000px 0;
  }
  100% {
    bottom: 25px;
    backgroud-position: 0 0;
  }
}
@keyframes round {
  from {
    left: 0;
  }
  to {
    left: -100%;
  }
}
@keyframes ran {
  from {
    backgroud-position: 0 0;
  }
  to {
    background-position: 1000px 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/modules/main-box.vue